<template>
  <article class="category flex flex-col">
    <div
      class="mb-[24px] flex flex-col gap-4 md:flex-row md:items-center md:justify-between"
    >
      <h1 class="font-roboto text-[32px] font-medium leading-6">
        Учителю и ученику
      </h1>

      <ClientOnly>
        <BaseTheButtonNew
          v-if="canEditLessons"
          type="secondary"
          icon="arrow-right"
          text="Созданные уроки"
          is-small
          href="/teacher/lessons"
        />
      </ClientOnly>
    </div>
    <div
      v-if="false"
      class="mb-8 h-auto rounded-xl px-6 pb-4 pt-6 text-[14px] leading-[22px] shadow-drop-0 transition-all duration-500"
    >
      <div class="flex">
        <div>
          <div
            class="font-roboto"
            :class="[
              isShowMore && isNotMobile ? 'text-[16px] font-medium' : '',
            ]"
          >
            В разделе «Учителю и ученику» представлены:
          </div>
          <ul>
            <li>
              - материалы по истории для школьного курса «История России» и
              «Всеобщая история» с 5 по 11 класс, структурированные по главам и
              параграфам единой линейки учебников с учетом Федеральных
              государственных образовательных стандартов (ФГОС);
              <span
                v-show="!isShowMore"
                class="ml-1 cursor-pointer select-none text-[#004AA1]"
                @click="isShowMore = true"
              >
                Подробнее...
              </span>
            </li>
            <li v-show="isShowMore">
              - дополнительные материалы для преподавателей и студентов системы
              среднего профессионального образования в соответствии с учебниками
              истории для СПО;
            </li>
            <li v-show="isShowMore">
              - статьи, лекции и интервью историков, публицистов и журналистов,
              дополненные профессиональными и архивными фото- и видео-
              материалами.
            </li>
          </ul>
          <div v-show="isShowMore" class="mt-2">
            Ресурс незаменим для саморазвития и при подготовке к ВПР, ОГЭ, ЕГЭ и
            вступительным испытаниям, а также позволяет подготовиться учителю и
            ученику по любой из тем школьной программы, использовать достоверные
            материалы на уроках, в докладах и презентациях. Тесты к каждому
            разделу помогают проверить знания и могут быть использованы на
            уроках и во внеурочной работе по историческому просвещению.
          </div>
          <div v-show="isShowMore" class="mt-4">
            Раздел «Учителю и ученику» основан на материалах Российского
            военно-исторического общества, Общества «Знание», образовательной
            медиатеки «Лекторий «Достоевский» и других партнеров.
          </div>
        </div>
      </div>
      <div
        v-show="isShowMore"
        class="mb-2 mt-4 cursor-pointer select-none text-[#004AA1]"
        @click="isShowMore = false"
      >
        Свернуть
      </div>
    </div>
    <TeacherShelf
      v-for="(shelf, idx) in sortedData"
      :key="`title_${shelf.name}`"
      :shelf="shelf"
      :index="idx"
    />
    <DatesBlock class="mb-14 mt-16" with-calendar>
      <template #content>
        <!-- Временно скрыта -->
        <BaseTheSortedLine
          v-if="false"
          :data="categories"
          :selected-item="activeSort"
          @update:selected-item="handleActiveSort"
        />
        <div class="mb-4">
          <NuxtLink
            class="ml-auto block w-fit cursor-pointer text-[20px] font-medium leading-6"
            :to="linkDatesPage"
          >
            Смотреть все
          </NuxtLink>
        </div>
        <div class="relative">
          <DatesCardSlider :data="dates" @on-swiper="onSwiper" />
          <SlidersSliderControl
            type="prev"
            class="absolute left-0 top-35% z-10 hidden md:block"
            :class="isBeginning ? 'opacity-50' : 'cursor-pointer'"
            @click="slidePrev()"
          />
          <SlidersSliderControl
            type="next"
            class="absolute right-0 top-35% z-10 hidden md:block"
            :class="isEnd ? 'opacity-50' : 'cursor-pointer'"
            @click="slideNext()"
          />
        </div>
      </template>
    </DatesBlock>

    <TeacherProjectBlock :data="projects" class="mt-2" />

    <!-- <GameBanner class="mt-16" /> -->

    <TeacherThePartnersBanner class="mt-16" />
  </article>
</template>

<script setup>
import projects from '@/assets/data/projects';
import {
  LESSON_EXCLUDED_SHELF_IDS,
  TEACHER_VISIBLE_SHELF_IDS,
  TEACHER_VISIBLE_SUBJECT_IDS_BY_SHELF,
} from '@/dictionary';

const route = useRoute();
const router = useRouter();
const crumbsStore = useBreadcrumbsStore();
const { onSwiper, slideNext, slidePrev, isEnd, isBeginning } = useSwiper();
const { canEditLessons } = useLessonAccess();
const { lessonId } = useLessonQuery();
const { teachersCategory } = useTeachersCategory();
const data = computed(() => teachersCategory.data?.value);
const { datesCategories } = useDatesCategories();
const categories = computed(() => [
  { title: 'Все', id: null },
  ...(datesCategories.data?.value || []),
]);

const { isNotMobile } = useBreakpoint();

const isShowMore = ref(false);

// при наборе материалов для урока полки, недоступные конструктору, с витрины убираем
const visibleShelfIds = computed(() =>
  lessonId.value
    ? TEACHER_VISIBLE_SHELF_IDS.filter(
        (id) => !LESSON_EXCLUDED_SHELF_IDS.includes(id),
      )
    : TEACHER_VISIBLE_SHELF_IDS,
);

// на части полок показываем не весь список учебников
const getVisibleSubjects = ({ id, subjects }) => {
  const visibleIds = TEACHER_VISIBLE_SUBJECT_IDS_BY_SHELF[id];

  return visibleIds
    ? subjects?.filter((subject) => visibleIds.includes(subject.id))
    : subjects;
};

const sortedData = computed(() => {
  return data.value
    ?.filter(({ id }) => visibleShelfIds.value.includes(id)) // TODO захардкодил фильтр чтобы не видели новые полки
    ?.map((shelf) => ({ ...shelf, subjects: getVisibleSubjects(shelf) }))
    ?.filter(({ subjects }) => subjects?.length)
    ?.map((shelf) => {
      return {
        ...shelf,
        subjects: [...shelf.subjects].sort((a, b) =>
          parseInt(a.school_class?.title) > parseInt(b.school_class?.title)
            ? -1
            : 1,
        ),
      };
    });
});

/** DATES DATA */
const days = computed(() => {
  const dateString =
    route.query?.days ||
    new Date().toLocaleDateString('ru-RU', {
      day: 'numeric',
      month: '2-digit',
    });

  if (!dateString) {
    return null;
  }

  if (dateString.includes('-')) {
    const [start, end] = dateString.split('-');
    const startParts = start.split('.');
    const endParts = end.split('.');
    return {
      start_day: startParts[0],
      start_month: Number(startParts[1]),
      end_day: endParts[0],
      end_month: Number(endParts[1]),
    };
  } else {
    const parts = dateString.split('.');
    return {
      start_day: parts[0],
      start_month: Number(parts[1]),
      end_day: parts[0],
      end_month: Number(parts[1]),
    };
  }
});

const filters = computed(() => {
  return {
    category: route.query?.sort,
    ...(days.value && { ...days.value }),
  };
});

const { dateArticles } = useDateArticles({ filters, per_page: 15 });

const dates = computed(() => dateArticles?.data?.value?.data || []);

/** SORTING DATES*/
const linkDatesPage = computed(() => {
  return {
    name: 'teacher-historical-calendar',
    query: {
      ...route.query,
      sort: activeSort.value,
    },
  };
});

const activeSort = computed(() => {
  return Number(route.query.sort) || 0;
});

const handleActiveSort = (id) => {
  if (id === activeSort.value) return;

  router.replace({
    query: {
      ...route.query,
      sort: id ? id : undefined,
    },
  });
};

onBeforeMount(() => {
  crumbsStore.clearCrumbs();
});

useHead(() => ({
  title:
    'История РФ: Учителю и ученику | Материалы по истории для школьного курса «История России» и «Всеобщая история» с 5 по 11 класс',
  meta: [
    {
      name: 'description',
      content:
        'История Российской Федерации в статьях. Освещаем все вехи российской истории в статьях. Российское военно-историческое общество. Мы знаем правду.',
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: `${useHostApp()}/teacher`,
    },
  ],
}));
</script>

<style lang="scss" scoped>
ul {
  list-style-type: none;
  margin-block-start: 8px;
  margin-block-end: 8px;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 20px;
  unicode-bidi: isolate;
}
</style>
